/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Combining_SegmentsInputs */

const en_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combining audio segments...`)
};

const fr_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assemblage des segments audio...`)
};

const de_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiosegmente kombinieren...`)
};

const it_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combinazione di segmenti audio...`)
};

const ru_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение аудиофрагментов...`)
};

const es_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combinando segmentos de audio...`)
};

const zh_cn2_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并音频片段……`)
};

const ja_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ セグメントを結合しています...`)
};

const hi_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो खंडों को संयोजित करना...`)
};

const pt_pt2_audio_description_export_status_combining_segments = /** @type {(inputs: Audio_Description_Export_Status_Combining_SegmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combinando segmentos de áudio...`)
};

/**
* | output |
* | --- |
* | "Combining audio segments..." |
*
* @param {Audio_Description_Export_Status_Combining_SegmentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_combining_segments = /** @type {((inputs?: Audio_Description_Export_Status_Combining_SegmentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Combining_SegmentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_combining_segments(inputs)
	if (locale === "de") return de_audio_description_export_status_combining_segments(inputs)
	if (locale === "it") return it_audio_description_export_status_combining_segments(inputs)
	if (locale === "ru") return ru_audio_description_export_status_combining_segments(inputs)
	if (locale === "es") return es_audio_description_export_status_combining_segments(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_combining_segments(inputs)
	if (locale === "ja") return ja_audio_description_export_status_combining_segments(inputs)
	if (locale === "hi") return hi_audio_description_export_status_combining_segments(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_combining_segments(inputs)
	return en_audio_description_export_status_combining_segments(inputs)
});